import { STATUSES as STATS, TimeWorker } from '@shared/widgets/TimeWorker';
import { useMessagesCountStore, useUserStore } from '@lib/store';

export const STORE_PREFIX = '__PING_MESSAGES__';
export const STATUSES = STATS;

const TIME_STEP = 30000;

export const PingMessages = () => {
  const messagesCountStore = useMessagesCountStore();
  const userStore = useUserStore();

  const handleAction = () => {
    messagesCountStore.getMessagesCount(userStore.data!.refreshToken!);
  };

  return <TimeWorker time={TIME_STEP} action={handleAction} />;
};
